import React from "react";

import { PRODUCT_NAME } from "utilities/productName";

export default function useDocumentTitle(
  title: string,
  siteName = PRODUCT_NAME
) {
  React.useEffect(() => {
    const currentDocumentTitle = document.title;

    // Set the document title to the new title.
    // We append the site name for blind users who cannot see the site's favicon.
    document.title = `${title} · ${siteName}`;

    // The cleanup function restores the original document title.
    // This way, we don't have to worry about resetting the title back if the
    // user navigates back and forth between different routes.
    return function cleanup() {
      document.title = currentDocumentTitle;
    };
  }, [title, siteName]);
}
